var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#B68900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9811 8.89706L8.89706 2.8125L2.8125 8.89706L8.89706 11.1448L14.9811 8.89706ZM4.70475 8.38125L8.82956 4.16363C8.82956 4.16363 12.8621 8.28844 13.032 8.37113C13.2024 8.45325 10.2583 8.37113 10.2583 8.37113L8.89706 6.97894L7.52006 8.38125H4.70475ZM8.89706 11.5729L14.9811 9.30937L8.89706 14.9811L2.8125 9.34031L8.89706 11.5734V11.5729Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSai);
export default __webpack_public_path__ + "static/media/sai.7ae8bbe1002ad46b6c856aa9ef356a80.svg";
export { ForwardRef as ReactComponent };